var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"true-label":"true","false-label":"false"},on:{"change":_vm.changeHandler},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("记住密码")])}
var staticRenderFns = []

export { render, staticRenderFns }